<template>
  <!-- 设备 -->
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">
          <img
            class="arrow-left"
            src="../../../assets/img/arrow-left.svg"
            alt=""
            @click="pushBack"
          />
          <span class="ml20">{{ this.devName }}</span>
        </div>
      </div>
      <v-row class="tabs-demo__size">
        <v-col :span="22">
          <v-tabs v-model="activeName" size="S" name="tabs-s-card" type="card">
            <v-tab-pane label="设备信息" value="1">
              <DeviceInfo
                :devName="devName"
                :devId="devId"
                :devKey="devKey"
              ></DeviceInfo>
            </v-tab-pane>
            <v-tab-pane label="Topic 列表" value="2">
              <TopicList
                :devName="devName"
                :devId="devId"
                :devKey="devKey"
              ></TopicList>
            </v-tab-pane>
            <v-tab-pane label="物模型信息" value="3">
              <PhysicalModel
                :devName="devName"
                :devId="devId"
                :devKey="devKey"
              ></PhysicalModel>
            </v-tab-pane>
          </v-tabs>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import DeviceInfo from "@/components/device/device-info.vue";
import TopicList from "@/components/device/topic-list.vue";
import PhysicalModel from "@/components/device/physical-model.vue";
export default {
  components: { DeviceInfo, TopicList, PhysicalModel },
  data() {
    return {
      activeName: "",
      devId: "",
      devName: "",
      devKey: "",
      mainDevKey: '',
      dev_name:""
    };
  },
  created() {
    this.devName = this.$route.query.name;
    this.devId = this.$route.query.id;
    this.devKey = this.$route.query.key;
    this.mainDevKey = this.$route.query.mainDevKey
    this.dev_name = this.$route.query.dev_name;

  },
  methods: {
    pushBack() {
      if(this.$route.query.isMain) {
        this.$router.push({ name: "/deviceInfo-manage/device-list-info"});
      }else{
        this.$router.push({ name: "/deviceInfo-manage/device-list-info-child",
        query: {
          dev_key: this.mainDevKey,
          dev_name: this.dev_name,
        }})
      }
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
</style>
